// extracted by mini-css-extract-plugin
export default {"mainDiv":"StoreNameBanner_mainDiv__cjthe","store":"StoreNameBanner_store__gVtCo"};